import { render, staticRenderFns } from "./HistoryEventContainer.vue?vue&type=template&id=c04f5590"
import script from "./HistoryEventContainer.vue?vue&type=script&lang=js"
export * from "./HistoryEventContainer.vue?vue&type=script&lang=js"
import style0 from "./HistoryEventContainer.vue?vue&type=style&index=0&id=c04f5590&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports